import { render, staticRenderFns } from "./MyRecordDetail.vue?vue&type=template&id=3b988739&scoped=true&"
import script from "./MyRecordDetail.vue?vue&type=script&lang=js&"
export * from "./MyRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./MyRecordDetail.vue?vue&type=style&index=0&id=3b988739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b988739",
  null
  
)

export default component.exports